<template>
  <div class="main">
    <a-tabs
      :activeKey="activeKey"
      @change="handleTabClick">
      <a-tab-pane key="1" tab="未关闭">
          <question-list :status="'1'"></question-list>
      </a-tab-pane>
      <a-tab-pane key="2" tab="已关闭">
        <question-list :status="'2'"></question-list>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import QuestionList from './question/QuestionList'
  export default {
    name: 'Question',
    components: { QuestionList },
    mixins: [],
    data(){
      return{
        activeKey:'1',

      }
    },
    mounted(){

    },
    methods:{
      handleTabClick(key){
        this.activeKey = key
      }
    }
  }
</script>

<style scoped lang="less">
  .main{
    padding: 0px 10px;
  }
</style>